import styled from 'styled-components';

export const Slider = styled.div`
    position: relative;
    margin: 50px auto;
    width: 100%;
    max-width: 1920px;
    height: 324px;
    overflow: hidden;
`;

export const SliderLent = styled.div`
    position: relative;
    display: flex;
    flex-wrap: nowrap;
    width: ${p=>`${p.lentWidth}px`};
    margin-left: ${p=>`-${p.outMargin}px`};
`;
